// ── src/pages/SetupHotelPage.js ────────────────────────────────────
import React, { useState, useEffect } from "react";
import "./SetupHotelPage.css";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const SetupHotelPage = () => {
  // ⬇︎ pull in the merge‑helper, not the raw setter
  const { authData, updateAuthData } = useAuth();
  const [hotelId, setHotelId]   = useState(null);
  const [loading, setLoading]   = useState(false);
  const navigate                = useNavigate();

  /* ── trial status ─────────────────────────────────────────────── */
  const trialTime  = authData?.trialTime;         // undefined → never started
  const notStarted = trialTime == null;
  const expired    = trialTime != null && trialTime <= 0;

  /* ── redirect if trial already active & KYC done ─────────────── */
  useEffect(() => {
    if (authData?.isKycCompleted && trialTime > 0) {
      navigate("/dashboard");
    }
    if (authData?.hotelId) {
      setHotelId(authData.hotelId);
    }
  }, [authData, trialTime, navigate]);

  /* ── activate / renew handler ─────────────────────────────────── */
  const handleRequest = async (e, mode) => {
    e.preventDefault();
    if (!hotelId) return alert("No hotel associated with your account.");

    setLoading(true);
    try {
      const endpoint  = mode === "activate" ? "/trial/activate" : "/trial/renew";
      const { data }  = await axios.post(
        endpoint,
        { hotelId },
        { headers: { Authorization: `Bearer ${authData.token}` } }
      );

      /* server returns { token, remainingTrialDays, … } */
      updateAuthData({
        token: data.token,
        trialTime: data.remainingTrialDays
      });

      alert(
        mode === "activate"
          ? "Trial activated successfully!"
          : "Trial renewed successfully!"
      );
      navigate("/dashboard");
    } catch (err) {
      console.error(`Error on ${mode}:`, err.response ?? err);
      alert(
        `Failed to ${
          mode === "activate" ? "activate" : "renew"
        } trial. Please try again.`
      );
    } finally {
      setLoading(false);
    }
  };

  /* ── ui ───────────────────────────────────────────────────────── */
  return (
    <div className="setup-hotel-container">
      <h1 className="setup-hotel-title">
        {notStarted
          ? "Activate Your Trial"
          : expired
          ? "Start Your Trial"
          : "Loading…"}
      </h1>

      <p className="setup-hotel-description">
        {notStarted && "Start your 30‑day free trial by clicking below."}
        {expired    && "Your trial expired. Start a new 30‑day period."}
      </p>

      {(notStarted || expired) && (
        <form
          className="setup-form"
          onSubmit={(e) => handleRequest(e, notStarted ? "activate" : "renew")}
        >
          <button type="submit" disabled={!hotelId || loading}>
            {loading
              ? notStarted
                ? "Activating…"
                : "Starting…"
              : notStarted
              ? "Activate Trial"
              : "Start Trial"}
          </button>
        </form>
      )}
    </div>
  );
};

export default SetupHotelPage;
